import React, { useState,useEffect } from 'react';
import { HashRouter, Route, Switch, useHistory ,useLocation } from 'react-router-dom';
import './scss/style.scss';
//import {browserHistory} from 'react-router';
import authService from './services/authService';
import sessionTimeOut from './services/sessionTimeOut';  
import TokenGenerate from './services/handleToken';

const loader = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/errors/Page404'));
const Page500 = React.lazy(() => import('./views/pages/errors/Page500'));

const App = () => {
  let location = useLocation();

  useEffect(
    () => {
      authService.validateRoute(location.hash);
    }, [location.hash])
  
  sessionTimeOut();

  // TokenGenerate();

  return (
    
    <HashRouter>
          <React.Suspense fallback="loader">
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/login/:page/:action/:id" name="Login Page" render={props => <Login {...props}/>} />
              {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} /> */}
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
  );
};

// class App extends Component {
//   constructor(props) {
//     super(props);
    
//   }

//   componentDidMount() {
//       console.log(this.props)

//   }
//   componentWillUnmount(nextProps) {
//     console.log(this.nextProps)


//   }

//   render() {
//     return (
//       <HashRouter>
//           <React.Suspense fallback="loader">
//             <Switch>
//               <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
//               {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} /> */}
//               <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
//               <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
//               <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
//             </Switch>
//           </React.Suspense>
//       </HashRouter>
      
//     );
//   }
// }

export default App;
